// PROFILE WIDGET
export const PROFILE_WIDGET_ACCOUNT_ID = "mts-profile-widget-accout";
export const PROFILE_WIDGET_ALL_SERVICES_ID = "mts-profile-widget-all-services";

// MAP
export const MAP_ELEMENT_ID = "mts-map-element";
